<template>
  <ul class="menu-nav">
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item menu-item-active"
    >
      <a
        href="#/dashboard"
        class="menu-link router-link-exact-active router-link-active"
      >
        <span class="menu-text"> Dashboard </span>
      </a>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
    >
      <a
        href="#/pilihkelasX"
        class="menu-link router-link-exact-active router-link-active"
      >
        <span class="menu-text"> Log Kelas X </span>
      </a>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
    >
      <a
        href="#/pilihkelasXI"
        class="menu-link router-link-exact-active router-link-active"
      >
        <span class="menu-text"> Log Kelas XI </span>
      </a>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
    >
      <a
        href="#/tertunda"
        class="menu-link router-link-exact-active router-link-active"
      >
        <span class="menu-text"> Siswa Tertunda </span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "KTMenu"
};
</script>
